export const REGISTER_FACEBOOK = 'REGISTER_FACEBOOK'
export const REGISTER_FACEBOOK_SUCCESS = 'REGISTER_FACEBOOK_SUCCESS'
export const REGISTER_FACEBOOK_ERROR = 'REGISTER_FACEBOOK_ERROR'

export const RegisterFacebook = (data) => ({
  type: REGISTER_FACEBOOK,
  payload: data
})
